import React from 'react';
import Whisper from 'rsuite/Whisper';
import IconButton from 'rsuite/IconButton';
import Popover from 'rsuite/Popover';
import Dropdown from 'rsuite/Dropdown';
import { WhisperSpeaker } from '../../../utils/whisper-speaker';

export const RecommendationActions = ({
  onEdit,
  onDelete,
}: {
  onEdit: () => void;
  onDelete: () => void;
}) => {
  const renderMenu: WhisperSpeaker = (
    { onClose, left, top, className },
    ref,
  ) => (
    <Popover ref={ref} className={className} style={{ left, top }} full>
      <Dropdown.Menu
        onSelect={(key) => {
          onClose();
          if (key === 'edit') onEdit();
          if (key === 'delete') onDelete();
        }}
      >
        <Dropdown.Item eventKey="edit">
          <i className="bi bi-pencil" />
          <span className="ps-2">Изменить</span>
        </Dropdown.Item>
        <Dropdown.Item eventKey="delete">
          <i className="bi bi-trash" />
          <span className="ps-2">Удалить</span>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Popover>
  );

  return (
    <Whisper placement="leftStart" trigger="click" speaker={renderMenu}>
      <IconButton
        appearance="subtle"
        icon={<i className="bi bi-three-dots" />}
      />
    </Whisper>
  );
};
